/**
 * Shared Redirect Loop Guard
 * 
 * Single counter shared between PublicRoute and ProtectedRoute.
 * React Router redirects happen synchronously in the same JS tick,
 * so Date.now()-based detection fails. We count redirects globally
 * and reset asynchronously via setTimeout(0).
 * 
 * If more than 3 redirects happen in the same tick, we break the loop.
 */

import { debugWarn } from './debugLogger';

let _syncRedirectCount = 0;
let _resetScheduled = false;

// Time-window guard: track redirects within a rolling window
const WINDOW_MS = 2_000;
const MAX_IN_WINDOW = 6;
let _windowTimestamps: number[] = [];

export function isSyncRedirectLoop(source: string): boolean {
  _syncRedirectCount++;
  if (!_resetScheduled) {
    _resetScheduled = true;
    setTimeout(() => {
      _syncRedirectCount = 0;
      _resetScheduled = false;
    }, 0);
  }

  // Time-window check (catches cross-tick loops)
  const now = Date.now();
  _windowTimestamps.push(now);
  _windowTimestamps = _windowTimestamps.filter((t) => now - t < WINDOW_MS);

  if (_syncRedirectCount > 3 || _windowTimestamps.length > MAX_IN_WINDOW) {
    debugWarn('auth', `[NetUno:AuthFlow] redirectLoopGuard::loop_broken`, {
      source,
      syncCount: _syncRedirectCount,
      windowCount: _windowTimestamps.length,
    });
    return true;
  }
  return false;
}
